import React, { useState } from "react";
import "./BookedAppointmentDetails.css";
import useTranslation from "../../hooks/use-translation";
import Details from "./rows";
import Dialog from "../Dialog-box";
import useBoolean from "../../hooks/use-boolean";
import getDirection from "../../images/get-direction.svg";
import BookApptIcon from "../../images/injection.svg";
import { useIsDesktop, useIsTablet } from '../../hooks/breakpoints';
import { useHistory } from "react-router-dom";

const BookedAppointmentDetails = ({
  type = "upcoming",
  detailsList = [],
  viewDetailClick,
  step = null,
  goBackClick,
  handleYesClick,
  appointmentData,
  rescheduleClick,
  qrCodeValue = ''
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const nameList = detailsList.filter(detail => detail?.key === 'Name of patient') || []
  const name = nameList[0]?.value || ''
  const [isOpen, open, close] = useBoolean();

  const getColorStyle = (list) => {
    let colorStyle = { color: "#333333" };
    if (list?.key === t("STATUS")) {
      if (list?.value?.toLowerCase().includes("confirmed")) {
        colorStyle = { color: "#51BAA9" };
      } else if (list?.value?.toLowerCase().includes("completed")) {
        colorStyle = { color: "#51BAA9" };
      } else if (list?.value?.toLowerCase().includes("cancelled")) {
        colorStyle = { color: "#B00020" };
      }
    }
    return colorStyle;
  };

  // const redirectToGoogleMaps = () => {
  //   const url =
  //     "http://maps.google.com/maps?daddr=" +
  //     appointmentData?.hosiptal_details?.lat +
  //     "," +
  //     appointmentData?.hosiptal_details?.lng;
  //   const win = window.open(url, "_blank");
  //   win.focus();
  // };


  return (
    <>
      <div
        className={`book-appointment-main-container ${step == 2 ? "mb70" : ""}`}
      >
        {step === 2 && (
          <button className="go-back-container" onClick={goBackClick}>
            <div className="left-arrow-icon"></div>
            <div className="go-back-text">{t("GO_BACK")}</div>
          </button>
        )}
        <div className="book-appointment-flex">
          <div className="book-appointment-container">
            <div className="book-appointment-header">
              <div className="book-appointment-left-container">
                <img
                  alt="book appointment"
                  src={BookApptIcon}
                  className="book-appointment-icon"
                />
                <div className="book-appointment-header-text">
                  {t("BOOKED_APPOINTMENT_DETAILS")}
                </div>
              </div>
              {(step === null || step === 1) && (
                <button
                  className="get-direction-text"
                  // onClick={() => history.push('/view-appointment-details')}
                  onClick={() => { viewDetailClick(appointmentData) }}
                >
                  {t("VIEW_DETAILS")}
                </button>
              )}
            </div>
            <div className="book-appointment-details">
              {detailsList?.map((list, index) => (
                <div key={index}>
                  <Details
                    t={t}
                    leftText={list?.key}
                    rightText={list?.value}
                    // showButton={list?.key === t("NEXT_DOSE_DATE") ? true : false}
                    styleClass={getColorStyle(list)}
                  />
                </div>
              ))}
            </div>

            {/* {type === "upcoming" && step !== null && (
              <div className="get-direction-call-container">
                <button
                  className="get-direction-container"
                  onClick={() => redirectToGoogleMaps()}
                >
                  <img
                    className="getDirection"
                    src={getDirection}
                    alt="getDirection"
                  ></img>
                  <div className="get-direction-text">{t("GET_DIRECTION")}</div>
                </button>
                <button className="call-button">
                  <div className="call-icon"></div>
                  <div className="call-button-text">
                    <a href={`tel:${appointmentData?.hosiptal_details?.contact}`}>
                      {appointmentData?.hosiptal_details?.contact}
                    </a>
                  </div>
                </button>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookedAppointmentDetails;
